<template>
	<div class="video-text-create-page">
		<!-- 导航栏：无右侧按钮，标题为AI创作 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">AI创作</div>
		</div>

		<!-- 主体区域 -->
		<div class="page-body">
			<!-- AI创作模块 -->
			<div class="result-section">
				<div class="section-header">
					<div class="section-title">AI创作</div>
					<!-- 未生成：显示生成文案按钮 -->
					<div v-if="!isGenerated" class="generate-btn" @click="handleGenerateText"
						:class="{disabled: !content.trim()}">
						生成文案
					</div>
					<!-- 已生成：显示重新生成+应用按钮组 -->
					<div v-else class="generate-result-btn-group">
						<!-- 重新生成：样式与下一步按钮一致 -->
						<div class="next-step-btn" style="margin-right: 1.6vw;" @click="handleRegenerate">
							重新生成
						</div>
						<!-- 应用按钮：样式参考AI创作按钮 -->
						<div class="generate-btn" @click="handleApply">
							应用
						</div>
					</div>
				</div>
				<!-- 文本框：高度自适应剩余空间减164px -->
				<textarea class="content-input" v-model="content" placeholder="请写下你想制作这条视频文案的背景和目标"
					@input="handleContentInput">
				</textarea>
			</div>

			<!-- 时长选择模块：文本框下方20px -->
			<div class="duration-select-wrapper" ref="durationWrapper" @click.stop="toggleDurationDropdown">
				<div class="duration-select-box">
					<!-- 左侧选中时长文字 -->
					<div class="duration-text">{{ selectedDuration.text }}</div>
					<!-- 右侧箭头图片 -->
					<img :src="isDropdownOpen ? require('@/assets/aiVideo/arrow_up.png') : require('@/assets/aiVideo/arrow_down.png')"
						class="arrow-icon" alt="arrow" />
				</div>

				<!-- 悬浮下拉框：展开时显示 -->
				<div class="duration-dropdown" v-if="isDropdownOpen">
					<div class="duration-item" v-for="item in durationOptions" :key="item.value"
						:class="{active: item.value === selectedDuration.value}" @click.stop="selectDuration(item)">
						{{ item.text }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		scriptCreate
	} from "@/api/poster";
	export default {
		name: "VideoTextCreatePage",
		data() {
			return {
				content: "", // 文本框内容
				isDropdownOpen: false, // 时长下拉框是否展开
				// 时长枚举：text展示文字，value传接口值（秒）
				durationOptions: [{
						text: '视频30秒（约100个字）',
						value: "100" // 原30 → 改为"100"
					},
					{
						text: '视频1分钟（约200个字）',
						value: "200" // 原60 → 改为"200"
					},
					{
						text: '视频1分30秒（约300个字）',
						value: "300" // 原90 → 改为"300"
					},
					{
						text: '视频2分钟（约400个字）',
						value: "400" // 原120 → 改为"400"
					}
				],
				selectedDuration: {
					text: '视频1分钟（约200个字）',
					value: "200"
				},
				isGenerated: false,
				currentPlatform: '',
			};
		},
		mounted() {
			document.title = "AI创作";
			// 新增：监听全局点击，点击外部关闭下拉框
			document.addEventListener('click', this.handleClickOutside);
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
		},
		beforeDestroy() {
			// 新增：销毁监听，防止内存泄漏
			document.removeEventListener('click', this.handleClickOutside);
		},
		methods: {
			handleClickOutside(e) {
				// 判断点击的元素是否在时长选择容器外
				if (this.$refs.durationWrapper && !this.$refs.durationWrapper.contains(e.target)) {
					this.isDropdownOpen = false;
				}
			},
			// 返回按钮
			onBack() {
				this.$router.back();
			},
			// 文本框输入事件：实时校验内容
			handleContentInput() {
				// 仅做输入监听，无需额外逻辑
			},
			// 切换时长下拉框展开/收起
			toggleDurationDropdown() {
				this.isDropdownOpen = !this.isDropdownOpen;
			},
			// 选择时长选项
			selectDuration(item) {
				this.selectedDuration = item;
				this.isDropdownOpen = false; // 选择后关闭下拉框
				console.log("点击后", this.isDropdownOpen)
			},
			// 生成文案按钮逻辑（接口暂空）
			async handleGenerateText() {
				if (!this.content.trim()) return; // 空内容时不执行
				let param;
				if (this.isGenerated) {
					param = {
						text: this.content,
						type: 'rewrite',
						num: this.selectedDuration.value
					}
				} else {
					param = {
						text: this.content,
						type: 'create',
						num: this.selectedDuration.value
					}
				}


				try {
					const res = await scriptCreate(param);
					console.log('请求结果', res);
					if (res) {
						this.content = res.text
						this.isGenerated = true
					}

				} catch (error) {
					console.log(error);
				}
			},
			handleRegenerate() {
				// this.isGenerated = false; // 先切回未生成状态
				this.handleGenerateText(); // 调用原生成文案逻辑
			},

			// 新增：应用按钮逻辑（跳转页面）
			handleApply() {
				this.$router.push({
					path: "videoTextconfirm",
					query: {
						content: this.content // 携带输入框/选题的content
					}
				});
			}
		}
	};
</script>

<style scoped>
	/* 页面基础布局（与原页面一致） */
	.video-text-create-page {
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	/* 导航栏（无右侧按钮） */
	.custom-nav-bar {
		width: 100%;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 主体区域：flex列布局，占满剩余高度 */
	.page-body {
		padding: 5.3333vw 4.8vw;
		box-sizing: border-box;
		background: #FFFFFF;
		flex: 1;
		min-height: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	/* 结果模块通用样式 */
	.result-section {
		flex: 1;
		/* 占满剩余高度（用于计算文本框高度） */
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	/* 标题/内容 头部（与原页面一致） */
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1.6vw;
		flex-shrink: 0;
	}

	.section-title {
		opacity: 0.9;
		font-family: SourceHanSansSC-bold;
		color: #1F2226;
		font-weight: 700;
		font-size: 4.2667vw;
		letter-spacing: -0.1333vw;
		font-style: normal;
		text-decoration: none;
		text-align: left;
	}

	/* 生成文案按钮样式 */
	.generate-btn {
		padding: 0.8vw 2.4vw;
		height: 5.3333vw;
		width: auto;
		display: flex;
		align-items: center;
		gap: 0.8vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #1570EE;
		cursor: pointer;
		box-sizing: border-box;
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
	}

	/* 按钮置灰样式：不可点击 */
	.generate-btn.disabled {
		/* background-color: #EBEBED;
		color: #666666; */
		cursor: not-allowed;
		opacity: 0.5;
	}

	/* 内容输入框：高度=剩余高度-164px（21.8667vw） */
	.content-input {
		width: 100%;
		flex: 1;
		height: calc(100% - 21.8667vw);
		/* 164px = 21.8667vw */
		padding: 2.6667vw 3.2vw;
		border-radius: 2.1333vw;
		border: 0.2667vw solid #D2DAE4;
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		outline: none;
		resize: none;
		box-sizing: border-box;
		background: #FFFFFF;
		line-height: 1.5;
		overflow-y: auto;
	}

	/* 时长选择容器：文本框下方20px（2.6667vw） */
	.duration-select-wrapper {
		margin-top: 2.6667vw;
		/* 20px */
		width: 48.5333vw;
		/* 364px = 364/7.5 */
		position: relative;
		/* 用于下拉框绝对定位 */
		flex-shrink: 0;
	}

	/* 时长选择框：宽364px 高60px */
	.duration-select-box {
		width: 100%;
		height: 8vw;
		/* 60px = 60/7.5 */
		border-radius: 2.1333vw;
		/* 与文本框圆角一致 */
		border: 0.2667vw solid #D2DAE4;
		box-sizing: border-box;
		padding: 1.6vw 2.6667vw;
		/* 上下12px=1.6vw，左右20px=2.6667vw */
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}

	/* 时长文字 */
	.duration-text {
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
	}

	/* 箭头图标：宽高24px */
	.arrow-icon {
		width: 3.2vw;
		/* 24px */
		height: 3.2vw;
		/* 24px */
		object-fit: contain;
	}

	/* 时长下拉框：悬浮在选择框上方8px */
	.duration-dropdown {
		position: absolute;
		bottom: calc(100% + 1.0667vw);
		/* 上方8px=1.0667vw */
		left: 0;
		width: 48.5333vw;
		/* 364px */
		border-radius: 2.1333vw;
		/* 16px=2.1333vw */
		border: 0.2667vw solid #D2DAE4;
		box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.2);
		/* 4px=0.5333vw */
		background-color: #FFFFFF;
		z-index: 99;
	}

	/* 时长下拉项：每行高60px */
	.duration-item {
		height: 8vw;
		/* 60px */
		box-sizing: border-box;
		padding: 0 2.6667vw;
		/* 左右20px */
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 0.1333vw solid #F0F0F0;
		/* 分割线 */
		font-size: 3.2vw;
		/* 24px */
		line-height: 4.5333vw;
		/* 34px */
	}

	/* 最后一个项去掉分割线 */
	.duration-item:last-child {
		border-bottom: none;
	}

	/* 未选中项文字样式 */
	.duration-item {
		font-family: SourceHanSansSC-regular;
		color: #333333;
		font-weight: 400;
		font-style: normal;
		text-decoration: none;
	}

	/* 选中项样式 */
	.duration-item.active {
		font-family: SourceHanSansSC-medium;
		color: #1570EE;
		font-weight: 500;
		background-color: #F6F9FB;
	}

	.generate-result-btn-group {
		display: flex;
	}

	.next-step-btn {
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}
</style>